import { useQuery } from "@tanstack/react-query";
import type { InvestmentIntelligence } from "@money/shared";
import { apiFetch } from "./client";

export function useInvestments() {
  return useQuery({
    queryKey: ["investments"] as const,
    queryFn: () => apiFetch<InvestmentIntelligence>("/investments"),
    staleTime: 60_000,
  });
}
